export default "__VITE_ASSET__Deszi17s__";